import { WebcamModule } from 'ngx-webcam';
import { NgZorroModule } from './../../ng-zorro.module';
import { CameraComponent } from './media-container/camera/camera.component';
import { SignaturePadComponent } from './media-container/signature-pad/signature-pad.component';
import { FileUploadComponent } from './media-container/file-upload/file-upload.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaContainerComponent } from './media-container/media-container.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    MediaContainerComponent,
    FileUploadComponent,
    SignaturePadComponent,
    CameraComponent,
  ],
  imports: [CommonModule, NgZorroModule, WebcamModule, SignaturePadModule, FormsModule],
  exports: [
    MediaContainerComponent,
    FileUploadComponent,
    SignaturePadComponent,
    CameraComponent,
  ],
})
export class MediaModule {}
